<script>
export default {
  name: "findOutMore",
  data() {
    return {
      link: "https://hddrenders.com/"
    };
  },
  methods: {
    goToLink() {
      window.open(this.link, "_blank");
    }
  }
};
</script>

<template>
  <el-row style="padding: 40px 0 40px 0; background-color: #2D2D2D">
    <el-col :span="24">
      <span class="title-bold">HDD Renders</span>
      <span class="paragraph"
        >Take great pride in delivering the best quality architectural
        renders</span
      >
      <span class="paragraph"
        >Our high-quality digital renders are used globally to assist with
        creating visual representations of finished real estate
        developments</span
      >
      <el-col
        :span="24"
        style="display: flex; justify-content: center; padding: 0 16px 16px 16px"
      >
        <el-button
          id="homePageCreativeAdsPrestigePartner"
          class="find-out-btn"
          type="primary"
          @click="goToLink"
          >Find out more
        </el-button>
      </el-col>
    </el-col>
  </el-row>
</template>

<style scoped>
.title-bold {
  color: #ffffff;
  font-feature-settings: "clig" off, "liga" off;
  font: 600 34px Metropolis, sans-serif;
  display: flex;
  justify-content: flex-start;
  padding: 0 16px;
}

.paragraph {
  color: #ffffff;
  font-feature-settings: "clig" off, "liga" off;
  font: 400 16px Metropolis, sans-serif;
  display: flex;
  justify-content: flex-start;
  padding: 0 16px;
  margin-top: 30px;
}

.find-out-btn {
  color: #ffbe00;
  text-align: center;
  border: 3px solid #ffbe00;
  background-color: #2d2d2d;
  width: 100%;
  margin-top: 40px;
  font: 600 20px Metropolis, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/package/findOutMore.vue